import { useState, useEffect } from "react";
import Modal from "../Modal/Modal";
import primaryComponents from "../../primaryComponents";

const RejectRequestModal = ({
  isActive,
  isOpen,
  closeModal = () => {},
  title = "Reject Request",
  description = "Rejecting this request will decline the request without altering inventory stock or financial balances.",
  reasonLabel = "Rejection Reason",
  placeholder = "Enter reason for rejection...",
  onConfirm = () => {},
  isLoading = false,
  submitBtnText = "Confirm Rejection",
  cancelBtnText = "Cancel",
  width = 520,
}) => {
  const active = isActive ?? isOpen ?? false;
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!active) {
      setReason("");
      setError("");
    }
  }, [active]);

  const handleClose = () => {
    if (isLoading) return;
    setReason("");
    setError("");
    closeModal();
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!reason.trim()) {
      setError("Please provide a reason for rejection.");
      return;
    }
    setError("");
    onConfirm(reason.trim());
  };

  return (
    <Modal isActive={active} closeModal={handleClose} width={width}>
      <div className="p-4">
        {title && <h4 className="mb-3 text-center">{title}</h4>}

        {description && (
          <div
            style={{
              backgroundColor: "#FFF5F5",
              padding: "16px",
              borderRadius: "8px",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            <p className="mb-0 text-danger">{description}</p>
          </div>
        )}

        <div className="mt-3">
          <label
            className="font-weight-medium mb-1"
            htmlFor="rejectionReasonInput"
          >
            {reasonLabel} <span className="text-danger">*</span>
          </label>
          <textarea
            id="rejectionReasonInput"
            className="form-control"
            rows={4}
            placeholder={placeholder}
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (error) setError("");
            }}
            style={{
              resize: "none",
              borderColor: error ? "#E02020" : undefined,
            }}
            disabled={isLoading}
          />
          {error && (
            <small className="text-danger mt-1 d-block font-weight-medium">
              {error}
            </small>
          )}
        </div>

        <div
          className="d-flex justify-content-between mt-4"
          style={{ gap: "16px" }}
        >
          <primaryComponents.Button
            classNames="btn btn--outline cover"
            onClick={handleClose}
            isDisabled={isLoading}
          >
            {cancelBtnText}
          </primaryComponents.Button>
          <primaryComponents.Button
            classNames="btn btn--danger cover"
            onClick={handleSubmit}
            isLoading={isLoading}
            isDisabled={isLoading}
            loadingText="Rejecting..."
          >
            {submitBtnText}
          </primaryComponents.Button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectRequestModal;
